import api from '@services/api';
import axios, { AxiosError } from 'axios';
import { toastError } from '@src/utility/Toast';
import { useQuery } from 'react-query';

const isSigned = async (token: any) => {
  try {
    if (token) {
      const { data } = await api.get('company/is-signed', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return data;
    }
  } catch (error) {
    let message = null;

    const err = error as Error | AxiosError;

    if (axios.isAxiosError(err)) {
      message =
        err.response?.data.message ||
        'Algo deu errado ao verificar a assinatura dos termos';
    } else {
      message = 'Erro no servidor';
    }

    toastError({ title: 'Atenção', description: message });
  }
};

export function useSignedTerms(token: string) {
  return useQuery('signedTerms', () => isSigned(token));
}

export default isSigned;
